import { render } from "./staff-block-qr.vue?vue&type=template&id=19ec9d61"
import script from "./staff-block-qr.vue?vue&type=script&lang=js"
export * from "./staff-block-qr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__